import { Box, styled, TextField } from '@material-ui/core';
import { SText } from '@setvi/shared/components';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(1, 3)
}));

const NoteContainer = styled(Box)(() => ({
  position: 'relative'
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    '& fieldset': {
      borderColor: '#E0E0E0'
    },
    '&:hover fieldset': {
      borderColor: '#1E96FC'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1E96FC',
      borderWidth: '2px'
    }
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(1)
  }
}));

const HelperText = styled(SText)(({ theme }) => ({
  fontSize: '12px',
  color: '#333D47',
  marginTop: theme.spacing(1)
}));

interface OverallNoteStepProps {
  note: string;
  onChange: (note: string) => void;
}

const MAX_CHARACTERS = 500;

export const OverallNoteStep = ({ note, onChange }: OverallNoteStepProps) => {
  const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue.length <= MAX_CHARACTERS) {
      onChange(newValue);
    }
  };

  const characterCount = note?.length || 0;
  const remainingCharacters = MAX_CHARACTERS - characterCount;

  return (
    <Container>
      <SText size="lg" weight="bold">
        Overall Note
      </SText>

      <Box>
        <NoteContainer>
          <StyledTextField
            multiline
            rows={3}
            value={note}
            onChange={handleNoteChange}
            placeholder="Add note"
            variant="outlined"
            fullWidth
            inputProps={{
              maxLength: MAX_CHARACTERS
            }}
          />
        </NoteContainer>

        <Box>
          {!note?.trim() && <HelperText>Please enter a note</HelperText>}
          {remainingCharacters < 50 && (
            <SText size="sm" color="error" style={{ marginTop: '4px' }}>
              {remainingCharacters} characters remaining
            </SText>
          )}
        </Box>
      </Box>
    </Container>
  );
};
